import React from 'react';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';

import { LOCALES } from './locales';
import messages from './messages';
import { getDomainConfig } from '../../services/domainService';

const I18nProvider = ({ children, locale }) => {
  const domainConfig = React.useMemo(() => getDomainConfig(), []);

  const finalLocale = locale || domainConfig.locale || LOCALES.PORTUGUESE;

  const finalMessages =
    messages[finalLocale] || messages[LOCALES.PORTUGUESE];

  return (
    <IntlProvider
      locale={finalLocale}
      textComponent={React.Fragment}
      messages={finalMessages}
    >
      {children}
    </IntlProvider>
  );
};

I18nProvider.propTypes = {
  children: PropTypes.node.isRequired,
  locale: PropTypes.string
};

I18nProvider.defaultProps = {
  locale: null
};

export default I18nProvider;
